export enum LabelEnum{
  NO_ACCESS = "noAccess",
  NO_SERVER = "noServer",
  TECHNICAL_ERROR = "ERR006"
}
